// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1ODVE","left":"InfoRow_left__1rv_E"};